<template>
  <div
    style="min-width: 1200px"
    class="big"
  >
    <div class="page_title flex_between">
      <span>编辑/查看不推荐名单</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="filterBox">
          <div class="flex">
            <div class="box flex">
              <div class="label">医生姓名</div>
              <el-input
                v-model="doctor_name"
                style="width: 160px"
                @change="search(1)"
              />
            </div>
            <div class="box flex">
              <div class="label">手机号</div>
              <el-input
                v-model="doctor_phone"
                style="width: 160px;margin-right:10px"
                @change="search(1)"
              />
              <el-button
                @click="search(1)"
                type="info"
                style="background-color:#eceff2;;color:#747981;"
              >查询</el-button>
            </div>
          </div>
        </div>
        <div
          style="text-align:left;margin-bottom:14px"
          class="flex_between"
        >
          <span>
            <span style="font-weight:700;font-size:16px">
              说明：
            </span>
            该名单中已选医生关联的患者在与该医生交流中不会在此入口推荐商品，该患者与其他医生交流仍推荐；交流特指该医生的开方页或待咨询页。
          </span>
          <div>
            <el-button
              type="primary"
              @click="addDocDia"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('902') : false
              "
            >添加医生</el-button>
            <el-button
              plain
              @click="removeDoctor"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('903') : false
              "
            >移除医生</el-button>
          </div>

        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="selectDoctorTable"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              prop="doctor_name"
              label="医生姓名"
            ></el-table-column>
            <el-table-column label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.sex == 1">男</span>
                <span v-if="scope.row.sex == 2">女</span>
                <span v-if="scope.row.sex == 0">未知</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="职称"
            ></el-table-column>
            <el-table-column
              prop="hospital"
              label="医院"
            ></el-table-column>
            <!-- <el-table-column
              prop="address"
              label="地区"
            ></el-table-column> -->
          </el-table>
        </div>
        <div style="margin-top:10px;text-align:left">
          共{{tableData.length}}条
        </div>
      </div>
    </div>
    <!-- 设置医生弹窗 -->
    <el-dialog
      title="添加医生"
      :visible.sync="addDoc"
      width="870px"
      :close-on-click-modal="false"
      :before-close="closeDia"
    >
      <div>
        <div class="searchbox">
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input
              v-model="doctor_name_d"
              size="medium"
              style="width: 120px"
              @change="search(0)"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">手机号</span>
            <el-input
              v-model="doctor_phone_d"
              size="medium"
              style="width: 120px"
              @change="search(0)"
            ></el-input>
          </div>
          <div class="item">
            <el-button
              type="primary"
              @click="search(0)"
              size="medium"
            >查询</el-button>
          </div>
        </div>
        <div style="padding: 0 10px">
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="doctorData"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column
                label="医生信息"
                width="150"
              >
                <template slot-scope="scope">
                  <div>
                    <span style="margin-right: 4px">{{
                      scope.row.doctor_name
                    }}</span>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span v-if="scope.row.sex == 0">未知</span>
                    <span style="margin-left: 4px">{{ scope.row.age }}岁</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                label="职称"
              ></el-table-column>
              <el-table-column
                prop="department_name"
                label="科室"
              ></el-table-column>
              <el-table-column
                prop="hospital"
                label="医院"
              ></el-table-column>
              <el-table-column
                prop="address"
                label="地区"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 10px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
      <div style="padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="setDoctor"
            size="medium"
          >添加，并继续查询</el-button>
          <el-button
            plain
            @click="closeDia"
            size="medium"
          >取消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      enter_id: this.$route.query.enter_id,
      tableData: [],
      doctor_ids: '',
      addDoc: false,
      doctor_name: '',
      doctor_phone: '',
      doctor_name_d: '',
      doctor_phone_d: '',
      hospital_d: '',
      doctorData: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      multipleSelection: [], //选择的医生列表
      selection: ''
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
    this.getDoctorList();
  },
  methods: {
    //获取不推荐医生列表
    getList() {
      let data = {
        enter_id: this.enter_id,
        page: 1,
        pageNumber: 10000
      };
      this.axios
        .post('platform/shop/getRecommendRuleDoctor', data)
        .then((res) => {
          this.totalNum = res.data.total;
          this.tableData = res.data.list;
        });
    },
    //获取选择医生列表
    getDoctorList() {
      let data = {
        doctor_name: this.doctor_name_d,
        phone: this.doctor_phone_d,
        hospital: this.hospital_d,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/TraditionDrug/getDoctorList', data)
        .then((res) => {
          if (res.code == 0) {
            this.doctorData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getDoctorList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getDoctorList();
    },
    //多选
    handleSelectionChange(val) {
      let selection = [];
      selection = val.map((item) => {
        return item.doctor_id;
      });
      this.selection = selection.toString();
    },
    //搜索
    search(type) {
      if (type) {
        this.getList();
      } else {
        this.currentPage = 1;
        this.getDoctorList();
      }
    },
    //打开弹窗
    addDocDia() {
      this.getDoctorList();
      this.addDoc = true;
    },
    //关闭弹窗
    closeDia() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.selection = '';
      this.addDoc = false;
      this.getList();
    },
    //设置不推荐医生
    setDoctor() {
      if (!this.selection) {
        this.$message.error('请先选择添加的医生');
        return false;
      }
      let data = {
        enter_id: this.enter_id,
        doctor_ids: this.selection
      };
      this.axios
        .post('platform/shop/saveRecommendRuleDoctor', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('添加成功');
            this.selection = '';
            this.getDoctorList();
          }
        });
    },
    //多选移除医生
    selectDoctorTable(val) {
      let selection = [];
      selection = val.map((item) => {
        return item.doctor_id;
      });
      this.doctor_ids = selection.toString();
    },
    //移除医生
    removeDoctor() {
      if (!this.doctor_ids) {
        this.$message.error('请先选择需要移除的医生');
        return false;
      }
      let data = {
        enter_id: this.enter_id,
        doctor_ids: this.doctor_ids
      };
      this.axios
        .post('platform/shop/delRecommendRuleDoctor', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('移除成功');
            this.doctor_ids = '';
            this.getList();
          }
        });
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.filterBox {
  margin-bottom: 10px;
  display: flex;
  .box {
    margin-right: 20px;
    display: flex;
    align-items: center;
    .label {
      margin-right: 10px;
    }
  }
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 5px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      display: inline-block;
      width: 80px;
      text-align: right;
      margin-right: 5px;
    }
  }
}
</style>



